import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SlidingTabsComponent } from './sliding-tabs.component';
import { FormsModule } from '@angular/forms';

@NgModule({
  declarations: [
    SlidingTabsComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
  ],
  exports: [
    SlidingTabsComponent
  ]
})
export class SlidingTabsModule { }
